/*
 *
 * Date: 2025
 * Description: Catalog title page , displaying the total number of parts found and their type
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Typography } from "@mui/material"
import { useContext } from "react";
//Interfaces
import { i_top_container_parts } from "../../interfaces/display.interfaces";

//Context
import { ThemeContext } from "../../context/context";

const TopPartsContainer = ( props : i_top_container_parts ) => {
    const titleContainer = { display : 'flex' , fontSize : 18 , fontWeight : '700'}
    const subTitle = { fontSize : 18 , fontWeight : '700' , textDecoration : 'underline' , marginLeft : '6px'  }
    const { mode } = useContext(ThemeContext)
    return (
        <Box sx={{ position: 'sticky', height : '48px', top: 0, zIndex: 10,width : '100%' ,backgroundColor: mode === 'Light' ? "white" : "#222" , border : '1px solid #EAECF0' , alignContent : 'center' , paddingLeft : '24px'}}>
                {props.count > 0 ?
                <>
                    {props.sku !== '' ?
                         <Typography component={'div'} sx={titleContainer}>
                            {props.count + ' Parts found for SKU including :' } 
                            <Typography sx={subTitle}>{props.sku}</Typography>
                        </Typography>
                    :
                        <Typography component={'div'} sx={titleContainer}>
                            {props.count + ' parts found for '} 
                            <Typography sx={subTitle}>{props.make + ' ' + props.model + ' ' + props.year}</Typography>
                        </Typography>
                    } 
                </>
                :
                <>
                 {props.sku !== '' ?
                     <Typography component={'div'} sx={titleContainer}>
                            {"No parts found for :" } 
                        <Typography sx={subTitle}>{props.sku}</Typography>
                        </Typography>
                    :
                    <Typography component={'div'} sx={titleContainer}>
                            {"No parts found for :" }  
                        <Typography sx={subTitle}>{props.make + ' ' + props.model + ' ' + props.year}</Typography>
                    </Typography>
                } 
                </>
                }
        </Box>
    )
}

export default TopPartsContainer;